


























import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';
import { OriginsData } from '@empathybroker/tsclient-stats/dist/models/origins/origins-data';

import { mapActions } from 'vuex';

import { IntersectElement, OriginsLanding, OriginsStep } from '../../components';
import { Params } from '../../components/insights/abstract.component';
import { Config, Data, OriginsComponent as Component, OriginsStepEnum } from '../../components/insights/origins/origins.component';

import { DefaultOriginIdEnum, PredictiveOriginIdEnum, RefinementOriginIdEnum } from '../../enums';

import { InsightsMixin } from '../../mixins/insights.mixin';

import { APP_CONSTS } from '../../store/app/app.consts';

export default {
  name: 'origins',
  components: {
    OriginsLanding,
    OriginsStep,
    IntersectElement
  },
  mixins: [
    InsightsMixin
  ],
  computed: {
    visibleSteps: function (): OriginsStepEnum[] {
      return (Object.values(OriginsStepEnum) as OriginsStepEnum[])
        .filter(step => (!!this.messages.steps[step] && (step <= this.currentStep)));
    },
    componentParams: function (): Params<Config, Data> {
      return {
        config: {
          defaultOriginIds: Object.values(DefaultOriginIdEnum),
          predictiveOriginIds: Object.values(PredictiveOriginIdEnum),
          refinementOriginIds: Object.values(RefinementOriginIdEnum),
          locale: this.$epb.locale,
          messages: {
            origins: this.messages.component.origins
          }
        },
        data: this.data
      };
    }
  },
  data: function () {
    return {
      currentStep: undefined,
      stepChangeEnabled: true,
      component: undefined,
      messages: this.$epb.messages.insights.origins
    };
  },
  methods: {
    ...mapActions(APP_CONSTS.moduleName, {
      setFiltersHidden: APP_CONSTS.actions.setFiltersHidden
    }),
    fetchData: async function (): Promise<OriginsData> {
      const originsReportResponse = await this.fetchStatsReport({
        id: StatsReportsIdsEnum.ORIGINS,
        params: {}
      });
      return originsReportResponse.data;
    },
    onContentEnter: function (): void {
      if (!!this.currentStep && !this.component) {
        this.component = new Component(this.$refs.component, this.componentParams);
      }
    },
    onStepChange: function (): void {
      if (!this.currentStep || (this.currentStep < OriginsStepEnum.DATA)) {
        this.stepChangeEnabled = false;
        if (!this.currentStep) {
          this.currentStep = OriginsStepEnum.DEFAULT;
        } else {
          this.currentStep++;
        }
        if (!!this.component) {
          this.component.setCurrentStep(this.currentStep);
        }
        if (this.currentStep === OriginsStepEnum.DATA) {
          this.setFiltersHidden(false);
        }
        this.$el.scrollTop = 0;
      }
    }
  },
  beforeDestroy: function (): void {
    if (!!this.component) {
      this.component.destroy();
    }
  },
  watch: {
    componentParams: {
      handler: function (componentParams: Params<Config, Data>): void {
        if (!!this.component) {
          this.component.update(componentParams);
        }
      },
      deep: true
    }
  }
};
